import { render, staticRenderFns } from "./FormA.vue?vue&type=template&id=615e58be&"
import script from "./FormA.vue?vue&type=script&lang=js&"
export * from "./FormA.vue?vue&type=script&lang=js&"
import style0 from "./FormA.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports